import i18n from "@/plugins/i18n";

function getMailtemplateColumns(handlers) {
  return getColumns(handlers, mailtemplateColumns);
}

function getColumns(handlers, columns) {
  return columns.map((column) => {
    if (column.type === "button") {
      column.actions.forEach((action) => {
        action.handler = getHandler(handlers, action);
      });
    }
    return column;
  });
}

function getHandler(handlers, action) {
  return handlers[action.key] || null;
}

const mailtemplateColumns = [
  {
    label: i18n.t("label.title"),
    field: "title",
    type: "text",
  },
  {
    label: i18n.t("label.actions"),
    type: "button",
    actions: [
      {
        icon: "edit",
        buttonClass: "md-primary md-simple",
        key: "edit",
        handler: null,
      },
    ],
  },
];

export { getMailtemplateColumns };